import { gql } from '@apollo/client';

export const CREATE_OBJECTIVE_CRITERION_MUTATION = gql`
    mutation ObjectiveCriterion($input: CreateObjectiveCriterionInput!) {
        Result:createObjectiveCriterion(input:$input){
            id
            objectiveId
            criterionTypeId
            targetCount
            targetValue
            weight
            isEnabled
            locales {
                    code,
                    name,
                    description
                }
            }
        }
    `;